import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, AfterViewInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
// Animations
import { slideInDownAnimation } from '../../app/app.animation';
// Common
import { AngularMaterialService, ErrorParseService, IEmailConfiguration, LGEDataService } from '../../commons';
// State
import { Store } from '@ngrx/store';
import * as fromEmailConfiguration from './state/email-configuration.selectors';
import * as EmailConfigurationAction from './state/email-configuration.actions';
import * as lgeApp from '../../app/state/app.actions';
import * as _ from 'lodash';
import { Observable, skipWhile, Subscription } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';


@Component({
    selector: 'email-configuration-screen',
    templateUrl: 'email-configuration.component.html',
    styleUrls: ['email-configuration.scss'],
    animations: [slideInDownAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmailConfigurationScreenComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input() pending$: Observable<boolean>;
    pendingSubscription: Subscription;
    pending: boolean;
    @Input() error$: Observable<string | null>;
    errorSubscription: Subscription;
    error: string | null;
    @Input() emailConfigData$: Observable<IEmailConfiguration | null>;
    emailConfigDataSubscription: Subscription;
    // emailConfigData: IEmailConfiguration | null;
    // emailTemplateData: IEmailConfiguration | null;

    isLoadingResults = false;
    showErrorMessage: string;
    isNullEmailTemplates: boolean = false;
    emailTemplateList = [];
    composeEmailData: any;
    emailTemplateData: any;
    showEmailTemplateDetail: boolean = false;
    showComposeEmail: boolean = false;
    isReadOnly: boolean = false;
    isReadOnlyList = ['APPROVED', 'PENDING APPROVAL', 'REJECTION', 'SUBMIT', 'WITHDRAWN', 'APPROVED MATCHING GIFT',
        'PENDING APPROVAL MATCHING GIFT', 'REJECTION MATCHING GIFT', 'SUBMIT MATCHING GIFT', 'WITHDRAWN MATCHING GIFT', 'OUTSTANDING TASK',
        'SUBMISSION COMMUNITY INVESTMENT', 'PENDING APPROVAL COMMUNITY INVESTMENT', 'SUBMISSION FOUNDATION',
        'PENDING APPROVAL FOUNDATION', 'SUBMISSION PLANT FOR THE PLANET', 'PENDING APPROVAL PLANT FOR THE PLANET',
        'SUBMISSION COMMUNITY GRANTS', 'PENDING APPROVAL COMMUNITY GRANTS', 'SUBMISSION EVENT SPONSORSHIP', 'PENDING APPROVAL EVENT SPONSORSHIP'];
    isReadOnlyData = [
        { emailTemplateName: 'APPROVED' },
        { emailTemplateName: 'PENDING APPROVAL' },
        { emailTemplateName: 'REJECTION' },
        { emailTemplateName: 'SUBMIT' },
        { emailTemplateName: 'WITHDRAWN' },
        { emailTemplateName: 'APPROVED MATCHING GIFT' },
        { emailTemplateName: 'PENDING APPROVAL MATCHING GIFT' },
        { emailTemplateName: 'REJECTION MATCHING GIFT' },
        { emailTemplateName: 'SUBMIT MATCHING GIFT' },
        { emailTemplateName: 'WITHDRAWN MATCHING GIFT' },
        { emailTemplateName: 'OUTSTANDING TASK' },
        { emailTemplateName: 'SUBMISSION COMMUNITY INVESTMENT' },
        { emailTemplateName: 'PENDING APPROVAL COMMUNITY INVESTMENT' },
        { emailTemplateName: 'SUBMISSION FOUNDATION' },
        { emailTemplateName: 'PENDING APPROVAL FOUNDATION' },
        { emailTemplateName: 'SUBMISSION PLANT FOR THE PLANET' },
        { emailTemplateName: 'PENDING APPROVAL PLANT FOR THE PLANET' },
        { emailTemplateName: 'SUBMISSION COMMUNITY GRANTS' },
        { emailTemplateName: 'PENDING APPROVAL COMMUNITY GRANTS' },
        { emailTemplateName: 'SUBMISSION EVENT SPONSORSHIP' },
        { emailTemplateName: 'PENDING APPROVAL EVENT SPONSORSHIP' }
    ];
    isNotSystemTemplateList = [];
    toAddList = [];

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    dataSource: MatTableDataSource<any>;

    displayedColumns = ['emailTemplateName'];

    constructor(
        private store: Store<fromEmailConfiguration.State>,
        private ref: ChangeDetectorRef,
        private fb: FormBuilder,
        private ams: AngularMaterialService,
        private errorParse: ErrorParseService,
        private _dataService: LGEDataService
    ) {
        this.selectState();
        this.createForms();
        // let emailTemplateData: any = {};
        // emailTemplateData.emailTemplateId = 0;
        // emailTemplateData.emailTemplateName = '';
        // emailTemplateData.subject = '';
        // emailTemplateData.formFields = '';
        // emailTemplateData.emailTemplateDescr = '';
        // emailTemplateData.systemTemplate = '';
        // emailTemplateData.deleteIt = '';
        // this.emailTemplateData = emailTemplateData
    }

    ngOnInit() {
        this.startSubscriptions();
        this.GetEmailTemplates();
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.store.dispatch(new EmailConfigurationAction.LoadEmailConfigurationState);
        })
    }

    GetEmailTemplates() {
        // this.isLoadingResults = true;
        this._dataService.GetEmailTemplates()
            .subscribe({
                next: data => {
                    // console.log(data);
                    // this.emailTemplateList = data;
                    this.isLoadingResults = false;
                    this.emailTemplateList = data.map((obj) => {
                        if (this.isReadOnlyList.indexOf(obj.emailTemplateName) > -1) {
                            obj.systemTemplate = true;
                        } else {
                            obj.systemTemplate = false;
                        }
                        return obj;
                    })
                    // console.log('updated emailTemplateList: ', this.emailTemplateList)
                    this.dataSource = new MatTableDataSource(this.emailTemplateList);
                    this.sortFilterPaginate();
                    this.ref.markForCheck();
                }, error: error => {
                    // console.log(error);
                    this.isLoadingResults = false;
                    this.showErrorMessage = 'Resource not available!';
                    this.ams.showAlert('Error!', 'Resource not available!');
                    this.ref.markForCheck();
                }
            });
        this.ref.markForCheck();
    }

    // Select state
    private selectState(): void {
        this.pending$ = this.store.select(fromEmailConfiguration.getEmailConfigurationScreenPending);
        this.emailConfigData$ = this.store.select(fromEmailConfiguration.getEmailConfigurationState).pipe(skipWhile(data => data === undefined || data === null));
        this.error$ = this.store.select(fromEmailConfiguration.getEmailConfigurationScreenError).pipe(skipWhile(error => error === undefined || error === null || error === ''));
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        this.dataSource.filter = filterValue;
    }

    sortFilterPaginate() {
        this.dataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
                default: return item[property];
            }
        };

        this.dataSource.filterPredicate = (data, filter: string) => {
            const accumulator = (currentTerm, key) => {
                return currentTerm + data[key];
            };
            const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
            // Transform the filter by converting it to lowercase and removing whitespace.
            const transformedFilter = filter.trim().toLowerCase();
            return dataStr.indexOf(transformedFilter) !== -1;
        };

        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    selectRow(row) {
        // console.log(row)
        this.showEmailTemplateDetail = true;
        this.isReadOnly = this.isReadOnlyList.indexOf(row.emailTemplateName) > -1 ? true : false;
        let emailTemplateData: any = {};
        emailTemplateData.emailTemplateId = row.emailTemplateId;
        emailTemplateData.emailTemplateName = row.emailTemplateName;
        emailTemplateData.subject = row.subject;
        emailTemplateData.formFields = '';
        emailTemplateData.emailTemplateDescr = row.emailTemplateDescr;
        emailTemplateData.systemTemplate = row.systemTemplate;
        emailTemplateData.deleteIt = row.deleteIt;
        this.emailTemplateData = emailTemplateData;
        this.ref.markForCheck();
    }

    onCancel(isShow) {
        this.showEmailTemplateDetail = isShow;
    }

    onAddEmailTemplate() {
        this.showEmailTemplateDetail = true;
        this.isReadOnly = false;
        let emailTemplateData: any = {};
        emailTemplateData.emailTemplateId = null;
        emailTemplateData.emailTemplateName = '';
        emailTemplateData.subject = '';
        emailTemplateData.formFields = '';
        emailTemplateData.emailTemplateDescr = '';
        emailTemplateData.systemTemplate = false;
        emailTemplateData.deleteIt = false;
        this.emailTemplateData = emailTemplateData;
        this.ref.markForCheck();
        // this.ams.showEmailTemplate('Email Template', 'Email Template', emailTemplateData, false, false, this.isReadOnlyList);
        // this.ams.emailTemplate.afterClosed().subscribe(result => {
        //     if (result) {
        //         // console.log(result);
        //         this.ams.showLoader('Loading...');
        //         this._dataService.EmailTemplateIUD(result)
        //             .then((response) => {
        //                 // console.log(response);
        //                 this.ams.closeDialog();
        //                 this.ams.showAlert('Success!', 'Successfully submitted!');
        //                 this.isLoadingResults = true;
        //                 this.GetEmailTemplates();
        //                 this.ref.markForCheck();
        //             }, error => {
        //                 // console.log(error);
        //                 this.ams.closeDialog();
        //                 this.showErrorMessage = 'Please try again later!';
        //                 this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
        //                 this.ref.markForCheck();
        //             });
        //     }
        // });
    }

    onComposeEmail() {
        this.ams.showLoader('Loading...');
        this._dataService.GetUsersGroupForRole('BASE')
            .subscribe({
                next: data => {
                    // console.log(data);
                    this.toAddList = _.sortBy(data.map(toAdd => toAdd.email));
                    this.ams.closeDialog();

                    this.isNotSystemTemplateList = _.differenceBy(this.emailTemplateList, this.isReadOnlyData, 'emailTemplateName');
                    // console.log(this.isNotSystemTemplateList);

                    if (this.emailTemplateList.length > 0) {
                        this.ams.showComposeEmail('Compose Email', 'Compose Email', this.isNotSystemTemplateList, this.toAddList);
                        this.ams.composeEmail.afterClosed().subscribe(result => {
                            if (result) {
                                // console.log(result);
                                this.ams.showLoader('Sending...');
                                this._dataService.SendEmailNotifications(result).subscribe(
                                    {
                                        next: (response) => {
                                            // console.log(response);
                                            this.ams.closeDialog();
                                            this.ams.showAlert('Success!', 'Successfully Sent!');
                                            this.ref.markForCheck();
                                        }, error: error => {
                                            // console.log(error);
                                            this.ams.closeDialog();
                                            this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                                            this.ref.markForCheck();
                                        }
                                    }
                                )
                            }
                        });
                    }
                    this.ref.markForCheck();
                }, error: error => {
                    // console.log(error);
                    this.ams.closeDialog();
                    this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                    this.ref.markForCheck();
                }
            });

    }

    public getTemplateName(name): string {
        const possibleName = ['APPROVED', 'PENDING APPROVAL', 'REJECTION', 'SUBMIT', 'APPROVED MATCHING GIFT', 'PENDING APPROVAL MATCHING GIFT',
            'REJECTION MATCHING GIFT', 'SUBMIT MATCHING GIFT', 'WITHDRAWN MATCHING GIFT', 'OUTSTANDING TASK', 'SUBMISSION COMMUNITY INVESTMENT',
            'PENDING APPROVAL COMMUNITY INVESTMENT', 'SUBMISSION FOUNDATION', 'PENDING APPROVAL FOUNDATION', 'SUBMISSION PLANT FOR THE PLANET',
            'PENDING APPROVAL PLANT FOR THE PLANET', 'SUBMISSION COMMUNITY GRANTS', 'PENDING APPROVAL COMMUNITY GRANTS'];
        return possibleName.indexOf(name) > -1 && name;
    }

    private displayLoader(pending: boolean): void {
        if (pending) {
            setTimeout(() => {
                this.ams.showLoader('Loading...');
                this.ref.markForCheck();
            })
        } else {
            this.ams.closeDialog().then(() => {
                if (this.error !== null && this.error !== undefined && this.error !== '') {
                    this.displayError(this.error);
                }
            });
        }
    }

    private displayError(error: any): void {
        let errorMessage;
        if (this.errorParse.foundKeyWord(error, "CORPCOMMONWS")) {
            errorMessage = this.errorParse.translateCCError(error);
        } else {
            errorMessage = error instanceof Object ? error.message : error;
        }
        this.ams.showAlert("Loading Error", errorMessage);
        this.ams.alert.afterClosed().subscribe(result => {
            this.store.dispatch(new EmailConfigurationAction.EmailConfigurationScreenErrorReset());
        });
    }

    // Create reactive forms
    private createForms(): void {

    }
    // Opens sidenav if on mobile
    public openSidenav(): void {
        this.store.dispatch(new lgeApp.OpenSidenav());
    }
    // Subscribe to state data and mark it for changes
    private startSubscriptions(): void {
        this.pendingSubscription = this.pending$
            .subscribe(data => {
                this.pending = data;
                this.displayLoader(this.pending);
                this.ref.markForCheck();
            });
        this.errorSubscription = this.error$
            .subscribe(data => {
                this.error = data;
                this.ref.markForCheck();
            });
        this.emailConfigDataSubscription = this.emailConfigData$
            .subscribe(data => {
                let templateList = JSON.parse(JSON.stringify(data));
                this.emailTemplateList = templateList.map((obj) => {
                    if (this.isReadOnlyList.indexOf(obj.emailTemplateName) > -1) {
                        obj.systemTemplate = true;
                    } else {
                        obj.systemTemplate = false;
                    }
                    return obj;
                });
                this.dataSource = new MatTableDataSource(this.emailTemplateList);
                this.sortFilterPaginate();
                this.showEmailTemplateDetail = false;
                this.ref.markForCheck();
            });
    }
    // Unsubscribe from state data changes
    private endSubscriptions(): void {
        this.pendingSubscription.unsubscribe();
        this.errorSubscription.unsubscribe();
        this.emailConfigDataSubscription.unsubscribe();
        this.store.dispatch(new EmailConfigurationAction.LoadEmailConfigurationStateSuccess(null));
    }

    ngOnDestroy() {
        this.endSubscriptions();
    }
}